import { useCallback } from "react";
import { useAppStore } from "@/store";
import { ThemeType, useTheme } from "@/mds/themes/theme-context";
import { GatedFeature } from "@/store/feature-gates/types";
import { PaywallContext } from "@/domains/metrics";

/**
 * Encapsulates the shared theme selection logic used by both the settings
 * appearance dropdown and the sidebar theme submenu. Handles Pro paywall
 * gating for Dark and System themes.
 */
export function useThemeSelection() {
  const { themePreference, setTheme } = useTheme();
  const { store } = useAppStore();
  const isPaid = store.subscriptions.personalSubscription?.isPaid ?? false;

  const selectTheme = useCallback(
    (id: string) => {
      const needsPro = id === ThemeType.HarvestMoon || id === ThemeType.System;
      if (needsPro && !isPaid) {
        store.subscriptions.openUsageLimitUpsell({
          feature: GatedFeature.DarkMode,
          context: PaywallContext.DarkModeToggle,
        });
        return false;
      }
      setTheme(id as ThemeType);
      return true;
    },
    [isPaid, setTheme, store.subscriptions]
  );

  return { themePreference, isPaid, selectTheme };
}
